import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)',
      boxShadow: '0 4px 20px rgba(109, 40, 217, 0.3)',
      zIndex: 1000,
      padding: '1rem 0'
    }}>
      <div style={{maxWidth: '1200px', margin: '0 auto', padding: '0 2rem'}}>
        <nav style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          {/* Logo */}
          <Link to="/" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            textDecoration: 'none',
            fontFamily: 'Space Grotesk, sans-serif',
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#ffffff'
          }}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <rect width="40" height="40" rx="8" fill="rgba(255,255,255,0.2)"/>
              <path d="M12 12h10c3 0 5 2 5 4.5c0 1.5-0.8 2.8-2 3.5c1.5 0.5 2.5 2 2.5 3.5c0 2.5-2 4.5-5 4.5h-6v-7l5-1c1 0 2-0.5 2-1.5s-1-1.5-2-1.5h-9.5v-4z" fill="#ffffff"/>
              <circle cx="28" cy="28" r="3" fill="#f59e0b"/>
            </svg>
            <span>RMQ Digital</span>
          </Link>
          
          {/* Desktop Navigation */}
          <ul style={{
            display: 'flex',
            gap: '2rem',
            listStyle: 'none',
            margin: 0,
            padding: 0,
            alignItems: 'center'
          }} className="desktop-nav">
            <li><Link to="/" style={{color: location.pathname === '/' ? '#f59e0b' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500', transition: 'color 0.3s'}}>Home</Link></li>
            <li><Link to="/services" style={{color: location.pathname === '/services' ? '#f59e0b' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500', transition: 'color 0.3s'}}>Services</Link></li>
            <li><Link to="/how-it-works" style={{color: location.pathname === '/how-it-works' ? '#f59e0b' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500', transition: 'color 0.3s'}}>How It Works</Link></li>
            <li><Link to="/compliance" style={{color: location.pathname === '/compliance' ? '#f59e0b' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500', transition: 'color 0.3s'}}>Compliance</Link></li>
            <li><Link to="/about" style={{color: location.pathname === '/about' ? '#f59e0b' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500', transition: 'color 0.3s'}}>About</Link></li>
          </ul>
          
          {/* CTA Button */}
          <Link to="/contact" style={{
            padding: '0.75rem 1.5rem',
            background: '#f59e0b',
            color: '#1f2937',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '0.95rem',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)'
          }} className="cta-button">
            Get Started
          </Link>
          
          {/* Mobile Menu Button */}
          <div 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              display: 'none',
              flexDirection: 'column',
              gap: '4px',
              cursor: 'pointer'
            }}
            className="mobile-menu-btn"
          >
            <span style={{width: '25px', height: '3px', background: '#fff', borderRadius: '2px'}}></span>
            <span style={{width: '25px', height: '3px', background: '#fff', borderRadius: '2px'}}></span>
            <span style={{width: '25px', height: '3px', background: '#fff', borderRadius: '2px'}}></span>
          </div>
        </nav>
        
        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div style={{
            display: 'none',
            flexDirection: 'column',
            gap: '1rem',
            marginTop: '1rem',
            padding: '1rem',
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '8px'
          }} className="mobile-nav">
            <Link to="/" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>Home</Link>
            <Link to="/services" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>Services</Link>
            <Link to="/how-it-works" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>How It Works</Link>
            <Link to="/compliance" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>Compliance</Link>
            <Link to="/about" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>About</Link>
            <Link to="/support" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>Support</Link>
            <Link to="/contact" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>Get Started</Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
